<template>
  <div class="ins-main">
    <img class="logo" src="@a/explore/logo.png" />
    <!-- 题目数量 -->
    <div class="questions-num">
        {{optionIdx}}/{{list.length-1}}
    </div>
    <!-- 题目块 -->
    <div class="quest-option">
        <h3 class="h3">{{list[optionIdx].divide}}</h3>
        <h4 class='h4'>{{list[optionIdx].question}}</h4>
        <span class="bt-right">Vocational Skills</span>
    </div>
    <!-- 选择 -->
    <div :class="['radio-group',list[optionIdx].options.length>2?'on':'']">
        <div class="radio" @click="selectQuestions(item[1])" v-for="(item,index) in list[optionIdx].options" :key="index">
            <div :class="['icon',score && isSelect(index)?'on':'']"></div><div>{{item[0]}}</div>
        </div>
    </div>
    <!-- 按钮块 -->
    <div class="sub-btn">
        <a @click="preHandle()" v-if="optionIdx>1" class="pre">上一题</a>
        <a @click="nextHandle()" v-if="score && boolBtn" class="nextBtn" :style="optionIdx==1?'margin-left:0;':''">下一题</a>
    </div>
    <!-- 继续答题 -->
    <van-popup  v-model="interruptShow" :close-on-click-overlay="false">
        <div class="confirm_box">
            <h2>是否从上次中断的位置继续答题？</h2>
            <div class="btn_group">
                <a class="confirm on" href="javascript:;" @click="isStorage(false)">重做</a>
                <a class="cancel" href="javascript:;" @click="isStorage(true)">继续答题</a>
            </div>
        </div>
    </van-popup>
  </div>
</template>

<script>
import { getStorage, setStorage, deleteStorage} from '@/utils/tools'
export default {
    data(){
        return{
            list:[],
            optionIdx:1,
            // 已选择的选项
            selectArr:[],
            // 选中了答案才显示下一步按钮
            boolBtn:false,
            // 添加时状态
            addBoold:true,
            // 判断是否有缓存
            interruptShow:false
        }
    },
    props:['list_'],
    computed:{
        isSelect(){
            return function(idx){
                return this.selectArr[this.optionIdx-1]  && (this.selectArr[this.optionIdx-1].score == this.list[this.optionIdx].options[idx][1])
            }   
        },
        /*
        *@param: arr
        *@return: arr || []
        *@Description: 判断当前是否是数组，如果不是则显示下一个并且返回空数组，否则返回数组
        *@MethodAuthor:  Zhang Xiao Guang
        *@Date: 2020-3-12 10:12:10
        */
        score(){
            return this.selectArr[this.optionIdx-1] && String(this.selectArr[this.optionIdx-1].score)
        },
        /*
        *@param: arr
        *@return: arr || []
        *@Description: 判断当前是否是数组，如果不是则显示下一个并且返回空数组，否则返回数组
        *@MethodAuthor:  Zhang Xiao Guang
        *@Date: 2019-10-31 16:12:10
        */
        isArray() {
            return arr => (arr instanceof Array ? arr : []);
        }
    },
    methods:{
        // 下一题
        nextHandle(){
            this.optionIdx+=1;
        },
        // 上一题
        preHandle(){
            this.optionIdx-=1;
        },
        // 选择后触发
        selectQuestions(val,bool){
            this.boolBtn = false;
            let idx = this.optionIdx;
            this.$set(this.selectArr,idx-1,{
                cid:this.list[idx].cid,
                eid:this.list[idx].eid,
                qid:this.list[idx].id,
                score:val,
            });
            if(this.selectArr.length==(this.list.length-1)){
                setStorage(this.$route.path,`${this.list[idx].cid}${this.list[idx].id}`,val);
                this.$emit('successful',this.selectArr);
                this.optionIdx = 1;
                this.selectArr = [];
            }else{
                
                if(val && this.addBoold){
                    this.addBoold = false;
                    // 延时等待css效果执行
                    if(bool){
                        this.optionIdx+=1;
                        this.boolBtn = true;
                        this.addBoold = true;
                    }else{
                        setTimeout(()=> {
                            this.optionIdx+=1;
                            this.boolBtn = true;
                            this.addBoold = true;
                        },600);
                    }
                    setStorage(this.$route.path,`${this.list[idx].cid}${this.list[idx].id}`,val);
                    
                }
            }
            
        },
        pullData(){
            this.list = this.list_;
            let idx = this.optionIdx;
            // 判断是否有缓存
            if(getStorage(this.$route.path,`${this.list[idx].cid}${this.list[idx].id}`)){
                this.interruptShow = true;
            }
        },
        // 读取缓存
        isStorage(bool){

            if(bool){
                for(let i=0;i<this.list.length;i++){
                    let item = String(getStorage(this.$route.path,`${this.list[i].cid}${this.list[i].id}`));
                    if(item && item!='undefined'){
                        this.selectQuestions(item,bool);
                    }
                }
            }else{
                let obj = window.localStorage.getItem(this.$route.path);
                // 提交删除缓存 
                for(let i=0;i<this.list.length;i++){
                    let item = String(getStorage(this.$route.path,`${this.list[i].cid}${this.list[i].id}`));
                    this.$delete(obj,`${this.list[i].cid}${this.list[i].id}`);
                }
                 window.localStorage.setItem(this.$route.path,obj);
                // deleteStorage(this.path);
            }
            this.interruptShow = false;
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.ins-main{
    background-color:#f0f0f0;
    position: fixed;
    top:0;
    left:-50%;
    width:100%;
    height:100%;
    max-width:750px;
    z-index:20;
    transform: translateX(-50%);
    transition:all .5s;
    overflow: auto;
    padding:30px;
    .logo{
        width: 137px;
        height: 56px;
        margin-bottom: 22px;
    }
    .questions-num{
        font-size:28px;
        color:#333;
        text-align:right;
        margin:0 auto 22px;
    }
    .quest-option{
        position: relative;
        background-color:rgba(237,212,2,1);
        border-radius:8px;
        color:#000;
        padding:50px;
        min-height:452px;
        margin-bottom:80px;
        text-align: justify;
        .h3{
            font-size:44px;
            font-weight:bold;
            margin-bottom:60px;
        }
        .h4{
            font-size:34px;
        }
        .bt-right{
            position: absolute;
            font-size:26px;
            font-weight:bold;
            bottom:50px;
            right:50px;
            z-index:2;
        }
    }
}
.ins-main.on{
    left:50%;
}
.radio-group{
    margin-bottom:200px;
}
.radio-group.on{
    margin-bottom:72px;
}
.radio-group .radio{
    margin-bottom:50px;
    font-size:34px;
    display:flex;
    line-height:42px;
    width: max-content;
    &:last-child{
        margin-bottom:0;
    }
    .icon{
        width:42px;
        height:42px;
        margin-left:40px;
        border:2px solid #CCCCCC;
        border-radius:50%;
        margin-right:20px;
    }
    .icon.on{
      background: url(../../assets/explore/is.png) center no-repeat;
      background-size: 100% 100%;
      border: none;
    }
}
.sub-btn{
    display:flex;
    justify-content: center;
    a.pre{
        display:block;
        width:174px;
        line-height:64px;
        border:2px solid rgba(28,149,212,1);
        border-radius:32px;
        text-align:center;
        font-size:34px;
        color:#1C95D4;
    }
    a.nextBtn{
        display:block;
        width:348px;
        line-height:64px;
        background:rgba(28,149,212,1);
        border-radius:32px;
        text-align:center;
        font-size:34px;
        color:#fff;
        margin-left:100px;
    }
}
</style>
